import React, { useState } from 'react';
import { CheckCircle2Icon, Loader2Icon, LockIcon } from 'lucide-react';
import { services } from '../data/services';
import { site } from '../data/site';
type Status = 'idle' | 'submitting' | 'success' | 'error';
export function QuoteForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [service, setService] = useState('');
  const [details, setDetails] = useState('');
  const [error, setError] = useState('');
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || phone.replace(/\D/g, '').length < 10 || !service) {
      setError('Please add your name, a 10-digit phone number and the service you need.');
      setStatus('error');
      return;
    }
    setError('');
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };
  if (status === 'success') {
    return <div className="flex flex-col items-center py-8 text-center" role="status" data-id="element-244" data-mp="36t9fflofxl8g">
        <CheckCircle2Icon className="h-14 w-14 text-brand" aria-hidden="true" data-id="element-245" data-mp="3gpb65ylklf6q" />
        <h3 className="mt-4 font-display text-3xl font-bold text-ink" data-id="element-246" data-mp="3lnw41rdcnms0">You’re on the list, {name.split(' ')[0]}.</h3>
        <p className="mt-2 max-w-xs text-ink-muted" data-id="element-247" data-mp="3qkcu4r440b7q">
          We’ll call you within one business day with your free quote. Need it sooner?
        </p>
        <a href={site.phoneHref} className="mt-5 font-display text-2xl font-bold text-brand" data-id="element-248" data-mp="3hhrnwuqbkvq">
          Call {site.phone}
        </a>
      </div>;
  }
  const inputClass = 'w-full rounded-lg border border-line bg-white px-4 py-3 text-base text-ink placeholder:text-ink-muted/70 outline-none transition-colors duration-150 focus:border-brand focus:ring-2 focus:ring-brand/20';
  return <form onSubmit={onSubmit} noValidate className="space-y-3" data-id="element-249" data-mp="m7zjlz7qmcg1">
      <div className="grid gap-3 sm:grid-cols-2" data-id="element-250" data-mp="m9izvpte8nht">
        <label className="block" data-id="element-251" data-mp="r69cg35zp0yh">
          <span className="sr-only" data-id="element-252" data-mp="r7c3qc7855ex">Full name</span>
          <input className={inputClass} placeholder="Full name" value={name} onChange={e => setName(e.target.value)} autoComplete="name" data-id="element-253" data-mp="2n9nvfatslwgb" />
        </label>
        <label className="block" data-id="element-254" data-mp="2x0saeajgxhb5">
          <span className="sr-only" data-id="element-255" data-mp="2x1tnslnyifw1">Phone number</span>
          <input className={inputClass} placeholder="Phone number" type="tel" value={phone} onChange={e => setPhone(e.target.value)} autoComplete="tel" data-id="element-256" data-mp="2s8s31x12jm4j" />
        </label>
      </div>
      <label className="block" data-id="element-257" data-mp="3fymgogt7pepu">
        <span className="sr-only" data-id="element-258" data-mp="3fyuwohkmt059">Service needed</span>
        <select className={`${inputClass} ${service ? '' : 'text-ink-muted/70'}`} value={service} onChange={e => setService(e.target.value)} data-id="element-259" data-mp="3fw8ocfpx2glz">
          <option value="" data-id="element-260" data-mp="1lktw9s9fo532">What needs fixing?</option>
          {services.map(s => <option key={s.id} value={s.id} data-id="element-261" data-mp="1gn1um6izl4lo">
              {s.name}
            </option>)}
          <option value="other" data-id="element-262" data-mp="3s9dp2sk6l3x8">Something else</option>
        </select>
      </label>
      <label className="block" data-id="element-263" data-mp="117zz98lruxl">
        <span className="sr-only" data-id="element-264" data-mp="14ndi7mmovww">Project details</span>
        <textarea className={`${inputClass} resize-none`} rows={3} placeholder="Briefly describe the job (optional)" value={details} onChange={e => setDetails(e.target.value)} data-id="element-265" data-mp="3jfh9jwliupqs" />
      </label>

      {status === 'error' && <p className="text-sm font-medium text-red-600" role="alert" data-id="element-266" data-mp="3ehph91gyt1m2">
          {error}
        </p>}

      <button type="submit" disabled={status === 'submitting'} className="flex w-full items-center justify-center gap-2 rounded-lg bg-brand py-4 font-display text-xl font-bold uppercase tracking-wide text-white transition-colors duration-150 hover:bg-brand-dark disabled:opacity-80" data-id="element-267" data-mp="30ifxjrtjvpdc">
        {status === 'submitting' ? <>
            <Loader2Icon className="h-5 w-5 animate-spin" aria-hidden="true" data-id="element-268" data-mp="e0z0h2dwkmks" /> Sending…
          </> : 'Get My Free Quote'}
      </button>
      <p className="flex items-center justify-center gap-1.5 text-xs text-ink-muted" data-id="element-269" data-mp="92xlasjll7el">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-270" data-mp="41hx4rm4ikrz" /> No spam, no obligation. We reply within 1 business day.
      </p>
    </form>;
}